module.exports = __webpack_public_path__ + "media/images/Groupe 158-50bf9971765b0fc0aac9b8e1ee62b9bd.svg";